<template>
    <form-row title="MLS #">
        <div class="sm:w-1/2">
            <input-text
                name="mls_number"
                :value="property.mls_number"
                placeholder="#"
                :read_only="read_only"
                @change="fetchMlsData"
            />

            <p v-if="mls_loading"
                class="flex items-center mt-3 mb-0 text-sm text-blue-600 leading-snug"
            >
                <spinner class="w-5 h-5 mr-2 flex-none" />
                Retrieving property details from MLS ...
            </p>
        </div>
    </form-row>
</template>

<script>
import Spinner from '../../components/spinner.vue';
import { fetchMlsLookup } from '../../mls/fetch-mls-lookup';

export default {
    components: {
        Spinner,
    },

    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            mls_loading: false,
            mls_request_id: 0,
        }
    },

    methods: {
        async fetchMlsData(mls_number) {
            if (! mls_number) {
                return;
            }

            const request_id = ++this.mls_request_id;
            this.mls_loading = true;

            try {
                const response = await fetchMlsLookup(mls_number);

                if (request_id !== this.mls_request_id) {
                    return;
                }

                if (response?.data) {
                    this.$emit('mlsDataReceived', response.data);
                }
            } finally {
                if (request_id === this.mls_request_id) {
                    this.mls_loading = false;
                }
            }
        },
    },
}
</script>
